// 服务配置
export const services = {
    llmRag: {
        id: 'llm-rag',
        name: 'LLM + RAG Solutions',
        path: '/llm-rag-solutions',
        enabled: true,
        description: 'Combining small and large language models (LLMs) with RAG to build fast, accurate, and cost-effective systems — from document Q&A to multilingual support and knowledge assistants — with full MLOps support for deployment, monitoring, and scaling.',
        title: 'LLM + RAG Solutions'
    },
    computerVision: {
        id: 'computer-vision',
        name: 'Computer Vision Solutions',
        path: '/computer-vision-solutions',
        enabled: true,
        description: 'Providing robust, production-ready vision systems across manufacturing, healthcare, and beyond — including OCR for automated document processing, and integrated MLOps to ensure reliable performance in real-world environments.',
        title: 'Computer Vision Solutions'
    },
    consultation: {
        id: 'consultation',
        name: 'AI Strategy and Consultation',
        path: '/consultation',
        enabled: false, // temporarily disabled
        description: 'Helping businesses make informed and cost-effective AI adoption decisions, from identifying high-value use cases to developing comprehensive AI integration roadmaps, ensuring maximum return on AI investments.',
        title: 'AI Strategy and Consultation'
    }
};

// 获取所有启用的服务
export const getEnabledServices = () => {
    return Object.values(services).filter(service => service.enabled);
};

// 获取特定服务
export const getService = (serviceId) => {
    return services[serviceId];
}; 